module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appTemplate"
    }
  }, [_c('NotificationList'), _vm._v(" "), (_vm.tokenAcquired) ? _c('div', {
    attrs: {
      "id": "contentPart"
    }
  }, [_c('context-component', {
    attrs: {
      "activeMenu": _vm.activeMenu,
      "traitementEnCours": _vm.traitementEnCours,
      "tabItems": _vm.tabItems
    },
    on: {
      "navigateTo": _vm.navigateTo,
      "closeTab": _vm.onCloseTab,
      "toggleMenu": _vm.toggleStateModeMenu,
      "isCompleted": function($event) {
        _vm.isCompletedContext = true
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'active-menu body': _vm.activeMenu, 'body': !_vm.activeMenu
    }
  }, [(_vm.isCompletedContext) ? [(!_vm.estModeBloque() && _vm.isMenuVisible && _vm.isFeatureFlagLoaded) ? _c('menu-component', {
    on: {
      "toggleMenu": _vm.toggleStateModeMenu,
      "traitement": _vm.setTraitement
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.isCompletedContext) ? [(!_vm.estModeBloque()) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.toggleStateModeMenu
    }
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('modal-alerte', {
    ref: "modalAlerte"
  }), _vm._v(" "), _c('modal-cloture-paie', {
    ref: "modalCloturePaie"
  }), _vm._v(" "), _c('modal-virement-sepa', {
    ref: "modalVirementSepa"
  }), _vm._v(" "), _c('modal-devalidation-cloture-exercice', {
    ref: "modalDevalidationClotureExercice"
  }), _vm._v(" "), _c('modal-importer-topaze', {
    ref: "modalImporterTopaze"
  }), _vm._v(" "), _c('modal-envoi-bulletin', {
    ref: "modalEnvoiBulletin"
  }), _vm._v(" "), _c('modal-enquete-satisfaction', {
    ref: "modalEnqueteSatisfaction"
  }), _vm._v(" "), _c('modal-edition-fin-de-mois', {
    ref: "modalEditionFinDeMois"
  }), _vm._v(" "), _c('modal-edition-fin-de-mois-cumulees', {
    ref: "modalEditionFinDeMoisCumulees"
  }), _vm._v(" "), _c('modal-reedition-bulletins', {
    ref: "modalReeditionBulletins"
  }), _vm._v(" "), _c('modal-salaries', {
    ref: "modalSalaries"
  })], 1) : _c('div', {
    attrs: {
      "id": "loginPart"
    }
  }, [_c('authentication')], 1), _vm._v(" "), _c('modal-traitement-en-cours', {
    ref: "modalTraitementEnCours"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699b6153"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue.html
// module id = ehbX
// module chunks = 2